import countryInformationApisClient from '@/services/country-information';

class Countries {
  fetchCountries = async (searchText?: string) => {
    const response = await countryInformationApisClient.get(`countries`, {
      params: {
        pageSize: 500,
        searchText,
      },
    });
    return response.data;
  };
}

export const CountriesInstance = new Countries();
